import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import storageKeys from '../../constants/storageKeys';
import RecommendationQuiz from "../RecommendationQuiz";
import './styles.css';

import background from '../../../assets/app/background.png'
import chevron from '../../../assets/chevron.gif'

function PageLoader() {
  const [playAnimation, setPlayAnimation] = useState(true);
  const [open, setQuiz] = useState(false);

  // This will run one time after the component mounts
  useEffect(() => {
    const vkchquiz = JSON.parse(localStorage.getItem(storageKeys.VKCH_QUIZ));
    const vkchintro = JSON.parse(localStorage.getItem(storageKeys.VKCH_INTRO));
    if (vkchintro) setPlayAnimation(false);
    const afterPageLoad = () => {
      setQuiz(true);

    };
    const onPageLoad = () => {
      // set local storage
      setPlayAnimation(false);
      if (!vkchquiz) {
        setTimeout(() => {
          afterPageLoad();
        }, 1000)
      }

    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      localStorage.setItem(storageKeys.VKCH_INTRO, JSON.stringify(true));
      setTimeout(() => {
        onPageLoad();
      }, 5000)
    } else {
      window.addEventListener('load', onPageLoad);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);

  const closeQuiz = (close) => {
    setQuiz(close);
  };

  const containerVariants = {
    hidden: {
      opacity: 0,
      x: '100vw',
      transition: {
        type: 'fade',
        mass: 1,
        damping: 8,
        when: 'beforeChildren',
        staggerChildren: 1,
        duration: 1
      },
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        type: 'fade',
        mass: 1,
        damping: 8,
        when: 'beforeChildren',
        staggerChildren: 1,
      },
    }
  };
  return (
    <div>
      <motion.div
        className="loading-screen"
        variants={containerVariants}
        initial="hidden"
        animate={playAnimation ? "visible" : "hidden"}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            background: `#000000`,
            backgroundImage: `url(${background})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
          }}
        >
          <div className="container">
            <div className="loader">

              <img src={chevron} alt="" style={{ width: '400px', height: '250px' }} />
            </div>

          </div>
        </div>
      </motion.div>
      <RecommendationQuiz open={open} handleClick={closeQuiz} />
    </div>


  );
}
export default PageLoader;